import {
  chatSlice,
  selectLocalMessagesByConversationId,
  selectSelectedChatType,
  selectSelectedConversation,
  selectUploadedFilesByConversationId,
  selectSavedRepliesModalOpen,
  selectSelectedSavedReplyContent,
  selectSelectedSavedReplyType,
  selectConversationSharedProducts,
  selectSelectedShopperEventCategory,
} from './chatSlice';

import {
  notificationsSlice,
  selectCurrentNotification,
  type NotificationSeverity,
} from './notificationsSlice';

import {
  sessionSlice,
  selectCurrentLoginToken,
  selectCurrentRegionId,
} from './sessionSlice';

import {
  associateEventsSlice,
  selectCurrentIncomingConversationRequestEvent,
} from './associateEventsSlice';

export const chatSelectors = {
  selectLocalMessagesByConversationId,
  selectSelectedChatType,
  selectSelectedConversation,
  selectUploadedFilesByConversationId,
  selectSavedRepliesModalOpen,
  selectSelectedSavedReplyContent,
  selectSelectedSavedReplyType,
  selectConversationSharedProducts,
  selectSelectedShopperEventCategory,
};
export const notificationSelectors = {
  selectCurrentNotification,
};
export const sessionSelectors = {
  selectCurrentLoginToken,
  selectCurrentRegionId,
};
export const associateEventsSelectors = {
  selectCurrentIncomingConversationRequestEvent,
};

const { actions: chatActions } = chatSlice;
const { actions: notificationsActions } = notificationsSlice;
const { actions: sessionActions } = sessionSlice;
const { actions: associateEventsActions } = associateEventsSlice;

export * from './store';
export { chatActions };
export { notificationsActions, NotificationSeverity };
export { sessionActions };
export { associateEventsActions};
